import React from 'react'
import {Container} from '@bootstrap-styled/v4'
import algoliasearch from 'algoliasearch/lite'
import {InstantSearch, Pagination, Configure} from 'react-instantsearch-dom'

import HitsRow from 'src/components/util/HitsRow'
import SearchBox from 'src/components/util/SearchBox'
import PaginationWrapper from 'src/components/util/Pagination'
import Hit from './Hit'

import * as S from './styled'

const algolia = {
    appId: process.env.GATSBY_ALGOLIA_APP_ID,
    searchApiKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
    indexName: process.env.GATSBY_ALGOLIA_INDEX_POSTS
}

const searchClient = algoliasearch(algolia.appId, algolia.searchApiKey)

const BlogList = () => {
    return (
        <S.BlogListWrapper>
            <Container>
                <InstantSearch searchClient={searchClient} indexName={algolia.indexName}>
                    <Configure hitsPerPage={6}/>

                    <SearchBox />

                    <S.BlogListContent>
                        <HitsRow Hit={Hit}/>
                    </S.BlogListContent>

                    <PaginationWrapper>
                        <Pagination
                            showNext={false}
                            showPrevious={false}
                            showFirst={false}
                            showLast={false}
                            translations={{
                            page(currentRefinement) {
                                return currentRefinement;
                            },
                            ariaPrevious: 'Página anterior',
                            ariaNext: 'Próxima página',
                            ariaFirst: 'Primeira página',
                            ariaLast: 'Última pagina',
                            ariaPage(currentRefinement) {
                                return `Página ${currentRefinement}`;
                            }
                        }}/>
                    </PaginationWrapper>
                </InstantSearch>
            </Container>
        </S.BlogListWrapper>
    )
}

export default BlogList